module.exports = "/_next/static/images/inst_footer-95a862bae255833333b9c447532bf0be.png";